import { Modal } from '@fiverr-private/overlay';

export default Modal;
